import _defineProperty from "D:/FIS/KhanhHoa/Source_v2/SourceCode/GIS/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import TopHorizontalMenu from "@/components/top-horizontal-menu/top-horizontal-menu.vue";
import { Options, Vue } from "vue-class-component";
import { Getter, Mutation } from "vuex-class";
let App = class App extends Vue {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "isMobile", void 0);
    _defineProperty(this, "isFullScreen", void 0);
    _defineProperty(this, "setIsSupport_dvh", void 0);
    _defineProperty(this, "setInnerHeight", void 0);
  }
  beforeMount() {
    const isSupport_dvh = CSS.supports("height: 100dvh");
    this.setIsSupport_dvh(isSupport_dvh);
    if (!isSupport_dvh) {
      this.setAppHeight();
      window.addEventListener("resize", () => {
        this.setAppHeight();
      });
    }
  }
  beforeDestroy() {
    window.removeEventListener("resize", () => {});
  }
  setAppHeight() {
    const appHeight = window.innerHeight;
    this.setInnerHeight(appHeight);
    document.documentElement.style.setProperty("--app-height", appHeight + "px");
  }
};
__decorate([Getter("getIsMobile")], App.prototype, "isMobile", void 0);
__decorate([Getter("getIsFullScreen")], App.prototype, "isFullScreen", void 0);
__decorate([Mutation("setIsSupport_dvh")], App.prototype, "setIsSupport_dvh", void 0);
__decorate([Mutation("setInnerHeight")], App.prototype, "setInnerHeight", void 0);
App = __decorate([Options({
  components: {
    TopHorizontalMenu
  }
})], App);
export default App;